export enum SignatureType {
  Hand = 'hand',
  Email = 'email',
  SMS = 'sms',
}
